import React, { useState, useEffect, useContext } from 'react';

import Cookies from 'js-cookie';

import Dropdown from '../common/Dropdown'
import CampaignMenu from './CampaignMenu.js'

import { UserDataContext } from "../../App.js";

function ViewMenu(props) {

    // ------------ parameters ---------------

    // ------ inherited state variables ------
    let [currentChar, setChar] = [ props.state[0], props.state[1] ];
    let [layout, setLayout] = [ props.state[3], props.state[4] ];
    const [userData, setUserData] = useContext(UserDataContext);
    const [isPlaying, setIsPlaying] = props.state[8];

    // -------- local state variables --------
    const [isTTS, setIsTTS] = useState(/Tabletop/i.test(navigator.userAgent));
    const [localNumChars, setLocalNumChars] = useState(1);
    const [numChars, setNumChars] = props.numCharsArray || [localNumChars, setLocalNumChars];


    let menuOptions = [
            'View > Mobile',
            'View > Portrait',
            'View > Landscape',
            'View N characters',
            ...(userData.loggedIn ? ['View > DM'] : []),
          ];

    // -------------------------------------
    // EVENT HANDLER
    // -------------------------------------

    const handleMenu = async (selection) => {
        // Implement the various menu options here

        // ----------  VIEW MOBILE --------------
        if (menuOptions[selection] === 'View > Mobile') {
            setLayout("mobile")
        }


        // ----------  VIEW PORTRAIT --------------
        else if (menuOptions[selection] === 'View > Portrait') {
            setLayout("full")
        }

        // ----------  VIEW LANDSCAPE --------------
        else if (menuOptions[selection] === 'View > Landscape') {
            setLayout("landscape")
        }

        // ----------  VIEW LANDSCAPE --------------
        else if (menuOptions[selection] === 'View > DM') {
            setLayout("mobile-DM")
        }

        // --------------------  VIEW N ------------------------
        else if (menuOptions[selection] === 'View N characters') {

            // ----------  MOBILE: control number of character sheets shown  ----------
            if (layout === 'mobile' || layout === 'mobile-DM') {
                let nr_chars = prompt("Number of characters to show (1–8):", String(numChars));
                if (isNaN(parseInt(nr_chars))) { nr_chars = 1; }
                else { nr_chars = Math.min(8, Math.max(1, parseInt(nr_chars))); }
                setNumChars(nr_chars);
                return;
            }

            // ----------  DESKTOP: toggle multi-character view  ----------
            const showNChars = () => {
                const char01 = document.getElementById("charsheet-full");
                const char05 = document.getElementById("char-form-05");

                if (char05.style.display === 'none') {

                    let nr_chars = prompt("Number of characters to show:", '5' );
                    if (isNaN ( parseInt(nr_chars) ) ) { nr_chars = 5; }
                    else { nr_chars = Math.max( 1, parseInt(nr_chars) ) }
                    nr_chars = Math.min( 20, nr_chars )

                    char05.style.display = 'flex';
                    char01.classList.add('no-print');
                    char05.classList.remove('no-print');

                    // show characters 1..nr_chars
                    for ( let i=1; i <= nr_chars; i++) {
                        document.getElementById('char' + i + '-div').style.display = 'inline';
                    }
                    // hide characters nr_chars..20
                    for ( let i=nr_chars+1; i <= 20; i++ ) {
                        document.getElementById('char' + i + '-div').style.display = 'none';
                    }

                } else {

                    char05.style.display = 'none';
                    char05.classList.add('no-print');
                    char01.classList.remove('no-print');

                }
            }

            if (layout !== "full") {
                setLayout("full")
                setTimeout(function(){
                    showNChars()
                }, 1000);
            } else {
                showNChars()
            }

        }

    } // end of HANDLE FUNCTION


    
    // ------------- useEffect ---------------
    /*
    useEffect( () => {

        async function DoSomething () {    
          
        }

        DoSomething();

    }, [] ); //useEffect
    */

        // ------------  Return JSX  ----------------
    
    return (
    
        <>
        <Dropdown
            trigger = {<button className="nav-settings-button">View</button>}
            menu = { menuOptions.map ( ( option, idx) => {

                if  ( option === 'Change Campaign' ) return <CampaignMenu key={idx} {...props} />

                else return <button id={'view-option-' + idx } onClick={()=>handleMenu(idx)}>{option}</button>

                }
            )}
            divClass='menu-item sub-menu'
            menuClass="menu"
            onChildClose={props.onChildClose}
        />
        </>
    )

    };  // end of function

    export default ViewMenu